import React, { createContext, useContext, useState, useEffect } from "react";
import { hu, enUS, ro } from "date-fns/locale";
import translations from "./translations/index";

const LanguageContext = createContext(null);

const DATE_LOCALES = {
  hu,
  ro,
  en: enUS
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem("lang") || "hu";
  });

  useEffect(() => {
    localStorage.setItem("lang", language);
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => translations[language]?.[key] ?? key;

  return (
    <LanguageContext.Provider
      value={{ language, setLanguage, t, dateLocale: DATE_LOCALES[language] }}
    >
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    throw new Error("useLanguage must be used inside LanguageProvider");
  }
  return ctx;
}
